// extracted by mini-css-extract-plugin
export var locationCard = "_hl-0";